import { PageHeader } from '@repo/ui/components/page-header'
import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'
import { useTranslation } from '@/lib/i18n'
import { AnomaliesFilters } from './-components/anomalies-filters'
import { AnomaliesTable } from './-components/anomalies-table'
import { ResidencesTable } from './-components/residences-table'
import { KINDS } from './-lib/labels'

const searchSchema = z.object({
	kind: z.enum(KINDS).optional(),
	state: z.enum(['open', 'closed']).default('open'),
	page: z.number().int().min(1).default(1)
})

export const Route = createFileRoute('/(private)/invii/')({
	component: SendingsPage,
	validateSearch: searchSchema,
	search: { middlewares: [stripSearchParams(searchSchema.parse({}))] }
})

/**
 * The sendings, anomalies first: what has not arrived, with the command to act,
 * and under it each residence with the anomalies still open. No command here
 * changes an outcome.
 */
function SendingsPage() {
	const { t } = useTranslation()
	const { kind, state, page } = Route.useSearch()

	return (
		<main className='flex min-h-0 flex-1 flex-col gap-8 overflow-y-auto p-4 md:p-6'>
			<PageHeader title={t('admin-sending:page_title')} />
			<section
				aria-labelledby='sending-anomalies-title'
				className='flex flex-col gap-3'
			>
				<h2
					className='font-semibold text-base'
					id='sending-anomalies-title'
				>
					{t(
						state === 'open'
							? 'admin-sending:open_title'
							: 'admin-sending:closed_title'
					)}
				</h2>
				<div className='flex'>
					<AnomaliesFilters />
				</div>
				<AnomaliesTable kind={kind} page={page} state={state} />
			</section>
			<section
				aria-labelledby='sending-residences-title'
				className='flex flex-col gap-3'
			>
				<h2
					className='font-semibold text-base'
					id='sending-residences-title'
				>
					{t('admin-sending:residences_title')}
				</h2>
				<ResidencesTable />
			</section>
		</main>
	)
}
